module.exports = __webpack_public_path__ + "static/img/home-banner.a570e630.jpg";